import { LEGAL_FORM_TYPE } from '~shared/constants/legal-form-type.constant';
import { IAdvancedFormConfig } from '~shared/modules/advanced-form/models/advanced-form.model';

import { ADD_BUSINESS_INFO_FORM_CONFIG } from '../constants/add-business-info.constant';
import { EDIT_BUSINESS_INFO_FORM_CONFIG } from '../constants/edit-business-info.constant';
import { PRIVATE_INFO_FORM_CONFIG } from '../constants/edit-private-info.constant';
import { CHANGE_EMAIL_FORM_CONFIG } from '../constants/change-email.constant';
import { IPrivateInfo } from '../models/account-info.model';

export namespace AccountFormsConfigUtil {
  export function createChangeEmailConfig(email: string): IAdvancedFormConfig {
    return {
      ...CHANGE_EMAIL_FORM_CONFIG,
      initialFormData: { email },
    };
  }

  export function createEditBusinessInfoConfig(businessInfo, countries): IAdvancedFormConfig {
    const businessInfoPayload = createBusinessInfoPayload(businessInfo, countries);

    return {
      ...businessInfoPayload,
      ...EDIT_BUSINESS_INFO_FORM_CONFIG,
    };
  }

  export function createAddBusinessInfoConfig(businessInfo, countries): IAdvancedFormConfig {
    const businessInfoPayload = createBusinessInfoPayload(businessInfo, countries);

    return {
      ...businessInfoPayload,
      ...ADD_BUSINESS_INFO_FORM_CONFIG,
    };
  }

  export function createPrivateInfoConfig(privateInfo: IPrivateInfo): IAdvancedFormConfig {
    return {
      ...PRIVATE_INFO_FORM_CONFIG,
      initialFormData: privateInfo,
    };
  }

  function createBusinessInfoPayload(businessInfo, countries) {
    const { countryOptions, defaultCountry } = getCountriesData(countries);
    const initialFormData = {
      ...businessInfo,
      country: businessInfo.country || defaultCountry.id,
    };

    return {
      initialFormData,
      fieldsExtraOptions: {
        legalFormType: {
          options: LEGAL_FORM_TYPE,
        },
        country: {
          options: countryOptions,
        },
      },
    };
  }

  function getCountriesData(countries) {
    const defaultCountry = countries.find(country => country.default);
    const countryOptions = countries.map(({ name: label, id: value }) => ({ label, value }));

    return { countryOptions, defaultCountry };
  }
}
